import { prop } from "fw";
import { dispatch } from "fw-state";
import { FetchAlarmsNotificationsAction } from "state/notifications";

const SECOND = 1000;
const NOTIFICATIONS_POLLING_INTERVAL = 60 * SECOND;

export class Notifications {
    @prop(0) counter: number;
    @prop(false) triggerAnimation: boolean;

    private notificationsInterval = null;

    created() {
        dispatch(new FetchAlarmsNotificationsAction());
        this.startNotificationPolling();
    }

    detached() {
        this.stopNotificationPolling();
    }

    startNotificationPolling() {
        this.notificationsInterval = setInterval(() => dispatch(new FetchAlarmsNotificationsAction()), NOTIFICATIONS_POLLING_INTERVAL);
    }

    stopNotificationPolling() {
        clearInterval(this.notificationsInterval);
    }
}
